var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWireConnectionDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 158,
    viewBox: "0 0 55 158",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69403",
    "data-name": "Group 69403",
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64914",
    "data-name": "Path 64914",
    d: "M28.74,64.142h-2.9A4.644,4.644,0,0,1,21.206,59.5V54.7a1.019,1.019,0,1,1,2.039,0v4.8a2.6,2.6,0,0,0,2.6,2.6h2.9a2.6,2.6,0,0,0,2.6-2.6V54.716a1.019,1.019,0,1,1,2.038,0V59.5a4.644,4.644,0,0,1-4.643,4.642Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64915",
    "data-name": "Path 64915",
    d: "M39.3,55.735H15.285a1.022,1.022,0,0,1-.926-.6L9.093,43.7A1.013,1.013,0,0,1,9,43.272V19.567a1.019,1.019,0,0,1,1.019-1.019H24.28a1.019,1.019,0,0,1,0,2.038H11.038v22.46l4.9,10.65H38.647l4.9-10.65V20.586H30.306a1.019,1.019,0,1,1,0-2.038h14.26a1.019,1.019,0,0,1,1.019,1.019v23.7a1.013,1.013,0,0,1-.093.425L40.226,55.14A1.021,1.021,0,0,1,39.3,55.735Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64916",
    "data-name": "Path 64916",
    d: "M39.746,20.586a1.019,1.019,0,0,1-1.019-1.019V2.039H15.859V19.567a1.019,1.019,0,0,1-2.038,0V1.019A1.019,1.019,0,0,1,14.84,0H39.746a1.019,1.019,0,0,1,1.019,1.019V19.567a1.019,1.019,0,0,1-1.019,1.019Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64917",
    "data-name": "Path 64917",
    d: "M27.293,8.866a1.019,1.019,0,0,1-1.019-1.019V1.019a1.019,1.019,0,0,1,2.038,0V7.847A1.019,1.019,0,0,1,27.293,8.866Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64918",
    "data-name": "Path 64918",
    d: "M20.966,8.866a1.02,1.02,0,0,1-1.019-1.019V1.019a1.019,1.019,0,1,1,2.039,0V7.847a1.02,1.02,0,0,1-1.02,1.019Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64919",
    "data-name": "Path 64919",
    d: "M33.619,8.866A1.02,1.02,0,0,1,32.6,7.847V1.019a1.02,1.02,0,1,1,2.039,0V7.847a1.02,1.02,0,0,1-1.02,1.019Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64920",
    "data-name": "Path 64920",
    d: "M25.3,53.7h3.987V15.479a2,2,0,0,0-1.993-1.994h0A2,2,0,0,0,25.3,15.479Zm5.006,2.039H24.28a1.02,1.02,0,0,1-1.019-1.019V15.479a4.032,4.032,0,1,1,8.064,0V54.716a1.02,1.02,0,0,1-1.019,1.019Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_784",
    "data-name": "Line 784",
    y2: 157.999,
    transform: "translate(27.131 63.605)",
    fill: "none",
    stroke: "#2c2c2c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64921",
    "data-name": "Path 64921",
    d: "M43.5,88.479h1.58a2.535,2.535,0,0,1,2.532,2.531v2.618a.556.556,0,1,1-1.113,0V91.01a1.42,1.42,0,0,0-1.419-1.419H43.5a1.42,1.42,0,0,0-1.419,1.419v2.614a.556.556,0,1,1-1.112,0V91.01A2.535,2.535,0,0,1,43.5,88.479Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64922",
    "data-name": "Path 64922",
    d: "M37.733,93.067H50.84a.558.558,0,0,1,.505.325l2.874,6.246a.553.553,0,0,1,.051.232v12.939a.556.556,0,0,1-.556.556H45.931a.556.556,0,1,1,0-1.113h7.227V99.993L50.484,94.18h-12.4l-2.674,5.813v12.259h7.227a.556.556,0,1,1,0,1.113H34.858a.556.556,0,0,1-.556-.556V99.87a.552.552,0,0,1,.051-.232l2.875-6.246a.558.558,0,0,1,.505-.325Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64923",
    "data-name": "Path 64923",
    d: "M37.489,112.253a.556.556,0,0,1,.556.556v9.567H50.527v-9.567a.556.556,0,0,1,1.113,0v10.123a.556.556,0,0,1-.556.557h-13.6a.556.556,0,0,1-.556-.557V112.809a.556.556,0,0,1,.556-.556Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64924",
    "data-name": "Path 64924",
    d: "M44.286,118.649a.557.557,0,0,1,.556.557v3.726a.556.556,0,0,1-1.113,0v-3.726A.557.557,0,0,1,44.286,118.649Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64925",
    "data-name": "Path 64925",
    d: "M47.74,118.649a.557.557,0,0,1,.556.557v3.726a.556.556,0,0,1-1.113,0v-3.726A.557.557,0,0,1,47.74,118.649Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64926",
    "data-name": "Path 64926",
    d: "M40.833,118.649a.557.557,0,0,1,.556.557v3.726a.556.556,0,0,1-1.113,0v-3.726A.557.557,0,0,1,40.833,118.649Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64927",
    "data-name": "Path 64927",
    d: "M45.374,94.18H43.2v20.86a1.089,1.089,0,0,0,1.088,1.088h0a1.089,1.089,0,0,0,1.088-1.088Zm-2.733-1.113H45.93a.556.556,0,0,1,.556.556V115.04a2.2,2.2,0,1,1-4.4,0V93.623a.557.557,0,0,1,.556-.556Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64928",
    "data-name": "Path 64928",
    d: "M10.775,108.479H9.194a2.535,2.535,0,0,0-2.532,2.531v2.618a.557.557,0,1,0,1.113,0V111.01a1.42,1.42,0,0,1,1.419-1.419h1.58a1.42,1.42,0,0,1,1.419,1.419v2.614a.556.556,0,1,0,1.113,0V111.01a2.534,2.534,0,0,0-2.531-2.531Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64929",
    "data-name": "Path 64929",
    d: "M16.538,113.067H3.431a.558.558,0,0,0-.5.325L.051,119.638A.552.552,0,0,0,0,119.87v12.939a.556.556,0,0,0,.556.556H8.34a.557.557,0,0,0,0-1.113H1.113V119.993l2.674-5.813H16.182l2.674,5.813v12.259H11.629a.557.557,0,0,0,0,1.113h7.784a.556.556,0,0,0,.556-.556V119.87a.551.551,0,0,0-.051-.232l-2.875-6.246A.558.558,0,0,0,16.538,113.067Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64930",
    "data-name": "Path 64930",
    d: "M16.782,132.253a.556.556,0,0,0-.556.556v9.567H3.744v-9.567a.556.556,0,1,0-1.113,0v10.123a.556.556,0,0,0,.556.557H16.782a.556.556,0,0,0,.556-.557V132.809a.556.556,0,0,0-.556-.556Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64931",
    "data-name": "Path 64931",
    d: "M9.985,138.649a.557.557,0,0,0-.556.557v3.726a.556.556,0,1,0,1.113,0v-3.726a.557.557,0,0,0-.557-.557Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64932",
    "data-name": "Path 64932",
    d: "M6.531,138.649a.557.557,0,0,0-.556.557v3.726a.556.556,0,1,0,1.113,0v-3.726a.557.557,0,0,0-.557-.557Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64933",
    "data-name": "Path 64933",
    d: "M13.438,138.649a.557.557,0,0,0-.556.557v3.726a.557.557,0,1,0,1.113,0v-3.726a.557.557,0,0,0-.557-.557Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64934",
    "data-name": "Path 64934",
    d: "M8.9,114.18h2.176v20.86a1.089,1.089,0,0,1-1.088,1.088h0A1.089,1.089,0,0,1,8.9,135.04Zm2.733-1.113H8.34a.557.557,0,0,0-.556.557V135.04a2.2,2.2,0,0,0,4.4,0V113.624a.557.557,0,0,0-.555-.557Z",
    fill: "#2c2c2c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64935",
    "data-name": "Path 64935",
    d: "M27,143V87.5A8.5,8.5,0,0,1,35.5,79h0A8.5,8.5,0,0,1,44,87.5v1.474",
    fill: "none",
    stroke: "#2c2c2c",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64936",
    "data-name": "Path 64936",
    d: "M27.271,163V107.5a8.5,8.5,0,0,0-8.5-8.5h0a8.5,8.5,0,0,0-8.5,8.5v1.474",
    fill: "none",
    stroke: "#2c2c2c",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWireConnectionDark);
export default __webpack_public_path__ + "static/media/wire-connection-dark.05cb81ed6557773455fa9228d6daf8af.svg";
export { ForwardRef as ReactComponent };